module.exports = __webpack_public_path__ + "files/SPIADI2026 - BADICAUSE - Guide Technique.45180f8afcf886d4c5832388ff6fae58.pdf";